<template>
  <div>
    <!-- 创建订单 - 植体信息 -->
    <div class="input-form-wrap-row" v-if="subCatalogId == '1010210' || subCatalogId == '1010220'" v-show="designFlag">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>修复体材质</span>
      </div>
      <el-select class="input-form" v-model="dataInfo.repairMaterial" placeholder="请选择修复体材质" size="mini">
        <el-option class="option-item" label="氧化锆" value="00" style="display: block;"></el-option>
        <el-option class="option-item" label="玻璃陶瓷" value="01" style="display: block;"></el-option>
        <el-option class="option-item" label="树脂" value="02" style="display: block;"></el-option>
      </el-select>
    </div>
    <!-- 冠部是否开孔-->
    <div class="input-form-wrap" v-if="subCatalogId == '1010210' || subCatalogId == '1010220'"
      style="padding: 10px 0px;width: 280px;margin-left: 6px;" v-show="designFlag">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>冠部是否开孔</span>
      </div>
      <div class="input-radio" style="width: 130px;">
        <div class="input-radio-box">
          <el-radio v-model="dataInfo.posHole" label="0" aria-label="否">否</el-radio>
          <el-radio v-model="dataInfo.posHole" label="1" aria-label="是">是</el-radio>
        </div>
      </div>
    </div>
    <!-- 开孔直径 -- 仅=>种植上部修复冠 -->
    <input-number-field label="开孔直径" v-if="dataInfo.posHole=='1'&&!['1010120','1010410'].includes(this.subCatalogId)" required v-model="dataInfo.holeDiameter"
      style="line-height: 40px;margin-left: 4px;" :step="0.1" :suffixText="'mm'" v-show="designFlag"/>
    <!-- 植体系统 -->
    <div class="input-form-wrap-row" v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>植体系统</span>
      </div>
      <el-select class="input-select" filterable v-model="dataInfo.impSystem" placeholder="请选择植体系统" size="mini"
        @change="getSystem(dataInfo.impSystem)" :filter-method="filterSystem">
        <el-option v-for="(item,i) in impSystemList" :key="i" :label="item.implName"
          :value="item.implId" style="display: block;"></el-option>
      </el-select>
    </div>
    <div class="input-form-wrap-row" v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>植体型号</span>
      </div>
      <el-select class="input-select" v-model="tempModel" placeholder="请选择植体型号" @change="getModel" size="mini"
        filterable :filter-method="filterModel">
        <el-option v-for="item in impModelListTemp" :key="item.implId" :label="item.implName" :value="item.implId"
        style="display: block;">
        </el-option>
      </el-select>
    </div>
    <div class="input-form-wrap-row" v-if="dataInfo.impSystem === '其他'" v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>其他</span>
      </div>
      <el-input class="input-form" v-model="dataInfo.impExtra" size="mini" />
    </div>
    <!-- 导板类型 -->
    <div class="input-form-wrap-plate" v-if="common.serv.get(subCatalogId).isPlate == '1'"
      v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>导板类型</span>
      </div>
      <el-select class="input-select" v-model="dataInfo.plateType" placeholder="请选择导板类型" size="mini">
        <el-option v-for="item in common.dict.get('biz_plate_type')" :key="item.value" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
    </div>
    <!-- 扫描杆 -->
    <div class="input-form-wrap-row" v-show="!designFlag||subCatalogId=='1010120'"
      v-if="subCatalogId == '1010210' || subCatalogId == '1010220' || subCatalogId == '1010310' || subCatalogId == '1010320' || subCatalogId == '1010410' || subCatalogId == '1010510'|| subCatalogId == '1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>扫描杆</span>
      </div>
      <el-select class="input-select" v-model="dataInfo.scanningRod" placeholder="请选择扫描杆" size="mini">
        <el-option class="option-item" label="口内扫描杆" value="01" style="display: block;"></el-option>
        <el-option class="option-item" label="口外扫描杆" value="02" style="display: block;"></el-option>
      </el-select>
    </div>
    <div class="input-form-wrap-row" v-show="!designFlag||subCatalogId=='1010120'"
      v-if="subCatalogId == '1010210' || subCatalogId == '1010220' || subCatalogId == '1010310' || subCatalogId == '1010320' || subCatalogId == '1010410' || subCatalogId == '1010510'|| subCatalogId == '1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>扫描杆供应商</span>
      </div>
      <el-input class="input-form" v-model="dataInfo.scanningRodSupplier" size="mini" placeholder="请输入供应商信息"
        autocomplete="new-password" />
    </div>
    <div class="input-form-wrap-row" style="line-height:60px;" v-if="subCatalogId == '1010510'"
      v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>杆卡类型</span>
      </div>
      <el-input class="input-form" v-model="dataInfo.collar" size="mini" placeholder="请输入杆卡类型信息" />
    </div>
    <!-- 精密附件供应商及型号 -->
    <div class="input-form-precise" style="line-height:60px;" v-if="subCatalogId == '1010510'"
      v-show="!designFlag||subCatalogId=='1010120'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>精密附件供应商及型号</span>
      </div>
      <el-input class="input-form" v-model="dataInfo.subgingival" size="mini" placeholder="请输入精密附件供应商及型号信息" />
    </div>
    <!-- 桥架上部修复工艺 -->
    <div class="input-form-wrap-craft" style="line-height:60px;" v-show="!designFlag||subCatalogId=='1010120'"
      v-if="common.serv.get(subCatalogId).isBriCraft == '1' && subCatalogId != '1010510'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>桥架上部修复工艺</span>
      </div>
      <div class="input-radio-box" style="padding-left: 30px;">
        <el-radio v-model="dataInfo.briCraft" label="01">氧化锆冠粘贴工艺</el-radio>
        <el-radio v-model="dataInfo.briCraft" label="02">树脂排牙工艺</el-radio>
      </div>
    </div>
    <div
      :class="subCatalogId=='1010510'||subCatalogId=='1010410'?'input-form-wrap addPadding':'input-form-wrap defaultPadding'"
      style="width: 27%;" :style="subCatalogId == '1010410' ? 'margin-left: 278px;' : 'margin-left: 11px;'"
      v-show="!designFlag"
      v-if="catalogId == '10' && subCatalogId != '1010698' && subCatalogId != '1010699' && subCatalogId != '1010700'">
      <div class="input-label">
        <span style="color:red">*</span>
        <span>口扫模型编辑</span>
      </div>
      <div class="input-radio">
        <div class="input-radio-box">
          <el-radio v-model="dataInfo.isEditScanModel" label="0"
            >否</el-radio>
          <el-radio v-model="dataInfo.isEditScanModel" label="1"
           >编辑模型文件{{ common.serv.get(subCatalogId).editScanModelBprice
            }}元</el-radio>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputNumberField from '../InputNumberField.vue';
import {
  mapState
} from 'vuex'
export default {
  data() {
    return {
      dataInfo: {
        impSystem: '',
        impModel: '',
        impExtra: '',
        plateType: '',
        scanningRod: '',
        scanningRodSupplier: '',
        collar: '',
        subgingival: '',
        briCraft: '01',
        isEditScanModel: '0',
        repairMaterial:'',
        posHole:'0',
        holeDiameter:'2.5'
      },
      impModelList: [],
      impSystemList: [],
      impModelListTemp: [],
      tempModel:'',
    }
  },
  props: {
    subCatalogId: {
      type: String,
      default: ''
    },
    catalogId: {
      type: String,
      default: ''
    },
    isEditServOrder: {
      type: String,
      default: '0'
    },
    // 设计需求显示 - 是/否
    designFlag:{
      type:Boolean,
      default: false
    },
    orderDetail:{
      type:Object,
      default:null
    },
    transmit:{
      type:Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['common', 'user'])
  },
  watch: {
    dataInfo: {
      handler() {
        let id = this.subCatalogId;
        if(this.designFlag){
          this.dataInfo.isEditScanModel = ''
          if(id=='1010120'&&id!='1010210'&&id!='1010220'&&!this.transmit){
            this.dataInfo.posHole = ''
          }
          this.dataInfo.holeDiameter = this.dataInfo.holeDiameter = ''?'2.5':this.dataInfo.holeDiameter
        }else{
          this.dataInfo.posHole = ''
          this.dataInfo.holeDiameter = ''
        }
        this.$emit('handleImp',this.dataInfo)
      },
      deep: true
    }
  },
  methods: {
    // 赋值植体list
    initImpSystemList() {
      let id = this.subCatalogId
      if (id == '1010210' || id == '1010220' ||
          id == '1010310' || id == '1010320' ||
          id == '1010410' || id == '1010510' ||
          id == '1010120') {
        // 适应症类型默认选中口外扫描杆
        this.dataInfo.scanningRod = '02'
      }
      this.impSystemList = this.common.implList;
    },
    //获取植体系统
    getSystem(impSystem) {
      this.impModelList = []
      var tempList = []
      for (let i = 0; i < this.common.implList.length; i++) {
        if (parseInt(impSystem) - 1001 == i) {
          tempList = this.common.implList[i].children;
          for (let j = 0; j < tempList.length; j++) {
            this.impModelList.push(tempList[j])
          }
        }
        this.impModelListTemp = this.impModelList;
        if (this.dataInfo.impSystem == this.common.implList[i].implId) {
          this.dataInfo.impSystem = this.common.implList[i].implName
        }
      }
      this.tempModel = this.dataInfo.impSystem == '其他' ? '其他' : this.dataInfo.impModel;
      this.dataInfo.impModel = this.tempModel;
      this.impModelListTemp = this.dataInfo.impSystem == '其他' ? [] : this.impModelList;
      sessionStorage.setItem('impModelListTemp', JSON.stringify(this.impModelListTemp))
      this.impSystemList = this.common.implList;
    },
    //获取植体型号
    getModel() {
      for (let i = 0; i < this.common.implList.length; i++) {
        for (let j = 0; j < this.common.implList[i].children.length; j++) {
          if (this.tempModel == this.common.implList[i].children[j].implId) {
            this.dataInfo.impModel = this.common.implList[i].children[j].implName
          }
        }
      }
    },
    // 过滤植体系统
    filterSystem(query) {
      if (query !== "") {
        this.impSystemList = this.common.implList.filter((item, index) => {
          return item.implName.toLowerCase().indexOf(query.toLowerCase()) > -1;
        })
      } else {
        this.impSystemList = this.common.implList;
      }
    },
    // 过滤植体型号
    filterModel(query) {
      if (query !== "") {
        this.impModelListTemp = this.impModelList.filter((item) => {
          return item.implName.toLowerCase().indexOf(query.toLowerCase()) > -1;
        })
      } else {
        this.impModelListTemp = this.impModelList;
      }
    },
    // 获取session  刷新或返回上一步
    getSession(){
      if(sessionStorage.getItem('form')||sessionStorage.getItem('updateForm')){
        let form = this.isEditServOrder=='1'?JSON.parse(sessionStorage.getItem('updateForm')):JSON.parse(sessionStorage.getItem('form'))
        for(const key in this.dataInfo){
          if(form[key]!=''){
            this.dataInfo[key] = form[key]
          }
        }
        this.tempModel = this.dataInfo.impModel
      }
      if(sessionStorage.getItem('impModelListTemp')){
        this.impModelListTemp = JSON.parse(sessionStorage.getItem('impModelListTemp'))
      }
    },
  },
  mounted() {
    this.initImpSystemList();
    this.getSession();
  },
  components: {
    InputNumberField
  },
}
</script>
<style lang="scss" scoped>
.order-input-wrap {
  width: 100%;
  position: relative;
}

.input-form-wrap-row,
.input-form-wrap-plate,
.input-form-precise,
.input-form-wrap-craft {
  width: 23%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 10px;
  font-size: 13px;
  margin-left: 1%;
  font-family: "宋体", Arial, sans-serif;

  /deep/ .input-label {
    width: 120px;
    text-align: left !important;
  }
}

.input-form-wrap {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-family: "宋体", Arial, sans-serif;

}

// 输入框
.input-form-wrap {
  width: 33.33%;
  padding: 3px 10px;
  font-size: 13px;

  /deep/ .input-label {
    text-align: left !important;
    width: 120px;
  }
}

.input-select,
.input-form,
.input-radio {
  width: 186px;
  height: 40px;
  display: flex;
  align-items: center;
}

.input-radio-box {
  width: 130px;
  height: 32px;
  padding-left: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
}
.input-form-precise,
.input-form-wrap-craft {
  width: 32.7%;
  margin-left: 1px;
  /deep/ .input-label {
    width: 150px;
  }
}
.input-form-precise {
  width: 32.7%;

  /deep/ .input-label {
    width: 150px;
  }
}
.input-form-wrap-craft {
  width: 24%;
  margin-left: 1%;
}
.addPadding{
  padding:20px 10px;
}
.defaultPadding{
  padding:10px;
}
</style>



// WEBPACK FOOTER //
// impSystem.vue?33d45568